/* eslint-disable no-console */
import config from 'config'
import ReactGA from 'react-ga'

const shouldTrackEvents = config.analyticsId && config.analyticsId !== 'none'

/**
 * Just so that we know what ReactGA.event expects
 * @param {string} category
 * @param {string} message
 * @param {string} details
 * @returns {*}
 */
const track = (category, message, details) =>
  ReactGA.event({
    category,
    action: message,
    label: `build: ${config.build} | ${details}`,
  })

const log = (event, message) => {
  if (!shouldTrackEvents) {
    console.log('logger log:', event, message)
  } else {
    track('log', event, message)
  }
}

const error = (event, message, details) => {
  if (!shouldTrackEvents) {
    console.log('logger error:', event, message, details)
  } else {
    // here each event is it's own category
    track(event, message, details)
  }
}

export const logger = {
  log,
  error,
}
